import { createActionGroup, emptyProps } from '@ngrx/store';

export const CheckTermsActions = createActionGroup({
  source: 'terms',
  events: {
    '[Check Terms] Terms Success': emptyProps(),
    '[Check Terms] Terms Failure': emptyProps(),
  },
});
